import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb1b9e64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "graphTimedistributionWeekend-component" }
const _hoisted_2 = { id: "graphTimedistribution-component" }
const _hoisted_3 = { class: "header-timeDistribution" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "charttimedistribution",
  style: {"width":"100%","height":"45vh"}
}, null, -1))
const _hoisted_5 = { id: "graphTimedistributionWeekend-component" }
const _hoisted_6 = { class: "header-timeDistribution" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "charttimedistributionWeekend",
  style: {"width":"100%","height":"45vh"}
}, null, -1))

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { onMounted, watch } from "vue";
import { Root } from "@amcharts/amcharts5";
import { Estimation } from "@/types/estimation.type";


export default /*#__PURE__*/_defineComponent({
  props: {
    data: null,
    point: null,
    tmoa: null
  },
  setup(__props: any) {

const props = __props as { data: Estimation[]; point: number; tmoa: any[] }



/* Chart code */
// Create root element
// https://www.amcharts.com/docs/v5/getting-started/#Root_element

onMounted(() => {
  redrawCharts();
});

let rootWeek: am5.Root | null = null;
let rootWeekend: am5.Root | null = null;

const redrawCharts = () => {
  // Recalcular datos

  if (rootWeek) {
    rootWeek.dispose();
  }

  if (rootWeekend) {
    rootWeekend.dispose();
  }
  const { dataGraphWeek, dataGraphWeekend } = getDataGraph();

  // Crear nuevos gráficos
  rootWeek = createChart("charttimedistribution", dataGraphWeek);
  rootWeekend = createChart("charttimedistributionWeekend", dataGraphWeekend);
};

const createChart = (idChart: string, data: Array<{ [key: string]: number | string }>) => {
  const root = Root.new(idChart);

  // Set themes
  // https://www.amcharts.com/docs/v5/concepts/themes/
  root.setThemes([am5themes_Animated.new(root)]);

  // Create chart
  // https://www.amcharts.com/docs/v5/charts/xy-chart/
  let chart = root.container.children.push(
    am5xy.XYChart.new(root, {
      panX: false,
      panY: false,
      layout: root.verticalLayout,
    })
  );

  // Add legend
  // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
  let legend = chart.children.push(
    am5.Legend.new(root, {
      centerX: am5.p50,
      x: am5.p50,
    })
  );

  // Create axes
  // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
  let xAxis = chart.xAxes.push(
    am5xy.CategoryAxis.new(root, {
      categoryField: "category",
      renderer: am5xy.AxisRendererX.new(root, {
        cellStartLocation: 0.1,
        cellEndLocation: 0.9,
        minGridDistance: 10,
      }),
      tooltip: am5.Tooltip.new(root, {}),
    })
  );

  xAxis.get("renderer").labels.template.adapters.add("text", function (text, target) {
    if (target.dataItem) {
      return target.dataItem.get("category").split("-")[1];
    }
    return text;
  });

  const xRenderer = xAxis.get("renderer");

  xRenderer.labels.template.setAll({
    fontSize: 10, //REDUCIR EL TAMAÑO DEL TEXTO
  });

  xAxis.get("renderer").grid.template.set("forceHidden", true);

  xAxis.data.setAll(data);

  let yAxis = chart.yAxes.push(
    am5xy.ValueAxis.new(root, {
      renderer: am5xy.AxisRendererY.new(root, {}),
      max: 100,
      min: 0,
      strictMinMax: true,
    })
  );

  // Add series
  // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
  function makeSeries(name, fieldName, color) {
    let series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: name,
        xAxis: xAxis,
        yAxis: yAxis,
        stacked: true,
        valueYField: fieldName,
        categoryXField: "category",
        stroke: color,
        fill: color,
      })
    );

    series.columns.template.setAll({
      tooltipText: "{name}: {valueY} %",
      width: am5.percent(90),
      tooltipY: 0,
    });

    series.data.setAll(data);
    series.appear();
  }

  // Leyenda
  let num = 10;
  props.tmoa.forEach((tmoa) => {
    makeSeries(`${tmoa.name}`, `s${num}`, am5.color(`${tmoa.color}`));
    num++;
  });

  // Make stuff animate on load
  // https://www.amcharts.com/docs/v5/concepts/animations/
  chart.appear(1000, 100);

  return root;
};

const getDataGraph = (): {
  data: Array<{ [key: string]: number | string }>;
  dataDonut: any;
} => {
  const { dataWeek, dataWeekend } = getTimeDistribution();
  const percentagesWeek = percentageByValueInEachRange(dataWeek);
  const percentagesWeekend = percentageByValueInEachRange(dataWeekend);

  const dataGraphWeek = [];
  const dataGraphWeekend = [];
  // 24 Barras para los diferentes rangos
  for (let num = 0; num < 24; num++) {
    const nameRange = `${num.toString().padStart(2, "0").toString()}:00`;
    const range = `gl-${nameRange}`;
    const elementWeek = {
      category: `${range}`,
    };
    const elementWeekend = {
      category: `${range}`,
    };
    // Número de tmoas por cada barra
    for (let index = 1; index < props.tmoa.length + 2; index++) {
      // lunes- viernes
      elementWeek[`s${9 + index}`] =
        percentagesWeek[`${nameRange}`] && percentagesWeek[`${nameRange}`][index.toString()]
          ? Number(percentagesWeek[`${nameRange}`][index.toString()].replace("%", ""))
          : null;

      // sábdo - domingo
      elementWeekend[`s${9 + index}`] =
        percentagesWeekend[`${nameRange}`] && percentagesWeekend[`${nameRange}`][index.toString()]
          ? Number(percentagesWeekend[`${nameRange}`][index.toString()].replace("%", ""))
          : null;
    }
    dataGraphWeek.push(elementWeek);
    dataGraphWeekend.push(elementWeekend);
  }

  return { dataGraphWeek, dataGraphWeekend };
};

/**
 * Separar las estimaciones por franjas horarias y por tipo de día (laborable o fin de semana).
 */
const getTimeDistribution = () => {
  const dataWeek: Record<string, number> = {};
  const dataWeekend: Record<string, number> = {};

  props.data?.forEach((item) => {
    const date = new Date(item.dateTime);
    const hour = date.getHours().toString().padStart(2, "0");
    const day = date.getDay();

    const range = `${hour}:00`;

    //- lunes -viernes
    if (day >= 1 && day <= 5) {
      if (!dataWeek[range]) {
        dataWeek[range] = [];
      }

      dataWeek[range].push(item.value);
    } else {
      if (!dataWeekend[range]) {
        dataWeekend[range] = [];
      }

      dataWeekend[range].push(item.value);
    }
  });

  return { dataWeek, dataWeekend };
};

const percentageByValueInEachRange = (rangos: any[]) => {
  const resultado = {};

  Object.keys(rangos).forEach((rango) => {
    const valores = rangos[rango];
    const total = valores.length;
    const conteo = {};

    // Contar apariciones
    valores.forEach((v) => {
      conteo[v] = (conteo[v] || 0) + 1;
    });

    // Convertir a porcentajes
    const porcentajes = {};
    Object.keys(conteo).forEach((valor) => {
      porcentajes[valor] = ((conteo[valor] / total) * 100).toFixed(2) + "%";
    });

    resultado[rango] = porcentajes;
  });

  return resultado;
};

watch(
  () => [...props.data],
  () => {
    redrawCharts();
  },
  { deep: true, immediate: false }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.graphTimedistribution")), 1)
      ]),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.graphTimedistributionWeekend")), 1)
      ])
    ]),
    _hoisted_7
  ]))
}
}

})